// import firebase from 'firebase/compat/app'
import { initializeApp } from "firebase/app";
import 'firebase/compat/database'
import { getFirestore } from 'firebase/firestore';
import connectWeb from'./configconnect/WebConnectionSetup.json';
import {getStorage} from "firebase/storage";


const FireBase = initializeApp ({
  apiKey: "AIzaSyDsjYIHwkr1mN3HpMzGT7RPIEQqGJeYt5w",
  authDomain: "pnfliffmember.firebaseapp.com",
  projectId: "pnfliffmember",
  storageBucket: "pnfliffmember.appspot.com",
  messagingSenderId: "699822498128",
  appId: "1:699822498128:web:314b9c81407686c3ff4c55",
  measurementId: "G-39V3YTFBSC"
});
const storage = getStorage(FireBase);
//const db = FireBase;


const db = getFirestore(FireBase);
/*
connectWeb.map(connectWeb=>{
  console.log(connectWeb.WebDatabaseAPIKey);

  apiKey =connectWeb.WebDatabaseAPIKey,
   authDomain= connectWeb.WebDatabaseAuthDomain,
   projectId= connectWeb.WebDatabaseProjectID,
  storageBucket= connectWeb.WebDatabaseStorageBucket,
  messagingSenderId= connectWeb.WebDatabaseMessagingSenderID,
  appId= connectWeb.WebDatabaseAppID,
  measurementId= connectWeb.WebDatabaseMeasurementID

})*/
/*
let dataconnectWeb = JSON.stringify(connectWeb)
let configconnectWeb= ""+dataconnectWeb;
const configWebdata = JSON.parse(configconnectWeb);
var firebaseConfig = {
  apiKey: configWebdata[0].WebDatabaseAPIKey,
  authDomain: configWebdata[0].WebDatabaseAuthDomain,
  projectId:configWebdata[0].WebDatabaseProjectID,
  storageBucket: configWebdata[0].WebDatabaseStorageBucket,
  messagingSenderId: configWebdata[0].WebDatabaseMessagingSenderID,
  appId: configWebdata[0].WebDatabaseAppID,
  measurementId: configWebdata[0].WebDatabaseMeasurementID
}
firebase.initializeApp(firebaseConfig)
export default getFirestore()
const databaseRef = firebase.database().ref()
export const notesRef = databaseRef.child("Customer")*/
//export default firebase
// Your web app's Firebase configuration
// let dataconnectWeb = JSON.stringify(connectWeb)
// let configconnectWeb= ""+dataconnectWeb;
// const configWebdata = JSON.parse(configconnectWeb);
// var firebaseConfig = {
//   apiKey: configWebdata[0].WebDatabaseAPIKey,
//   authDomain: configWebdata[0].WebDatabaseAuthDomain,
//   projectId:configWebdata[0].WebDatabaseProjectID,
//   storageBucket: configWebdata[0].WebDatabaseStorageBucket,
//   messagingSenderId: configWebdata[0].WebDatabaseMessagingSenderID,
//   appId: configWebdata[0].WebDatabaseAppID,
//   measurementId: configWebdata[0].WebDatabaseMeasurementID
//   };
  
  // Initialize Firebase
  // firebase.initializeApp(firebaseConfig);
// export Firebase so it can be used elsewhere
//  const FireBase = firebase.initializeApp(firebaseConfig);
// export default FireBase;
export {db, storage}
